export type PropertySpec = {
  type: string
  label: string
  name: string
  placeholder?: string
  property?: { [key: string]: any }
  styles?: { [key: string]: any }
  useDomainAttribute?: boolean
}
